'use strict';

/* eslint global-require: 0 */
module.exports = require('./Utils');


//////////////////
// WEBPACK FOOTER
// ./~/enzyme-adapter-utils/build/index.js
// module id = 530
// module chunks = 0